<template>
  <div class="g-container-box">
    <el-row class="g-header-container">
      <el-col :span="3">
        <div class="g-header-left">熟客控制台</div>
      </el-col>
      <el-col :span="16">
        <nav-head navSel="2"></nav-head>
      </el-col>
      <el-col :span="5">
        <op-head></op-head>
      </el-col>
    </el-row>

    <el-row class="g-view-container">
      <el-col :span="3" class="g-menu-container">
        <sidebar defaultSel="5"></sidebar>
      </el-col>

      <el-col :span="21" class="g-center-container">
        <div class="admin-page-card">
          <div class="page-head">
            <div>
              <div class="page-title">管理员账号</div>
              <div class="page-desc">管理员列表查询、新增管理员、删除管理员</div>
            </div>

            <el-button class="add-btn" type="warning" @click="handleAdd">
              添加账号
            </el-button>
          </div>

          <div class="table-card">
            <el-table
              :data="listData"
              border
              stripe
              v-loading="loading"
              class="admin-table"
              header-cell-class-name="table-header-cell"
              empty-text="暂无管理员数据"
            >
              <el-table-column
                prop="jobNo"
                label="管理员工号"
                min-width="140"
              ></el-table-column>

              <el-table-column
                prop="realName"
                label="姓名"
                min-width="140"
              ></el-table-column>

              <el-table-column
                prop="mobile"
                label="电话"
                min-width="160"
              ></el-table-column>

              <el-table-column
                prop="account"
                label="登录账号"
                min-width="160"
              ></el-table-column>

              <el-table-column
                prop="roleName"
                label="权限"
                min-width="160"
              >
                <template slot-scope="scope">
                  <span class="role-tag" v-if="scope.row.roleName">{{ scope.row.roleName }}</span>
                  <span v-else>--</span>
                </template>
              </el-table-column>

              <el-table-column
                label="操作"
                width="120"
                fixed="right"
                align="center"
              >
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    class="delete-btn"
                    :disabled="deleteLoading"
                    @click="handleDelete(scope.row)"
                  >
                    删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>

            <div class="pagination-wrap" v-if="total > 0">
              <el-pagination
                background
                layout="total, prev, pager, next, jumper"
                :current-page="pageNum"
                :page-size="pageSize"
                :total="total"
                @current-change="handleCurrentChange"
              >
              </el-pagination>
            </div>
          </div>
        </div>

        <el-dialog
          title="新增管理员"
          :visible.sync="dialog"
          width="620px"
          :close-on-click-modal="false"
          :destroy-on-close="true"
          class="admin-dialog"
        >
          <el-form
            ref="formRef"
            :model="formData"
            :rules="rules"
            label-width="110px"
            class="admin-form"
          >
            <el-form-item label="管理员权限" prop="roleId">
              <el-select
                v-model="formData.roleId"
                placeholder="请选择管理员权限"
                style="width: 100%;"
                clearable
              >
                <el-option
                  v-for="item in roleOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="账号" prop="account">
              <el-input
                v-model.trim="formData.account"
                maxlength="20"
                clearable
                placeholder="请输入登录账号"
              ></el-input>
            </el-form-item>

            <el-form-item label="工号" prop="jobNo">
              <el-input
                v-model.trim="formData.jobNo"
                maxlength="20"
                clearable
                placeholder="请输入管理员工号"
              ></el-input>
            </el-form-item>

            <el-form-item label="姓名" prop="name">
              <el-input
                v-model.trim="formData.name"
                maxlength="20"
                clearable
                placeholder="请输入姓名"
              ></el-input>
            </el-form-item>

            <el-form-item label="电话" prop="mobile">
              <el-input
                v-model.trim="formData.mobile"
                maxlength="30"
                clearable
                placeholder="请输入电话/微信"
              ></el-input>
            </el-form-item>

            <div class="pwd-tip">
              <i class="el-icon-info"></i>
              管理员账号初始密码为：<span>000000</span>
            </div>
          </el-form>

          <span slot="footer" class="dialog-footer">
            <el-button type="primary" :loading="submitLoading" @click="submitForm">
              确定
            </el-button>
            <el-button @click="dialog = false">取消</el-button>
          </span>
        </el-dialog>
      </el-col>
    </el-row>
  </div>
</template>

<script>
var util = require("@/common/util.js");

import { API_SCGLYL, API_GLYLIST, API_XZGLYLB } from "../../assets/js/api.js";
import sidebar from "../../components/sidebar.vue";
import navHead from "../../components/navHead.vue";
import opHead from "../../components/opHead.vue";

export default {
  name: "adminAccountPage",
  components: {
    sidebar,
    navHead,
    opHead,
  },
  data() {
    return {
      loading: false,
      submitLoading: false,
      deleteLoading: false,
      dialog: false,

      pageNum: 1,
      pageSize: 10,
      total: 0,
      allListData: [],

      // 这里的 id 先按占位写法处理
      // 你后面拿到后台真实 roleId，只需要改这里即可
      roleOptions: [
        { id: 4, name: "内容管理" },
        { id: 5, name: "订单售后" },
        { id: 3, name: "团长管理" },
        { id: 7, name: "发票管理" }
      ],

      // { id: 2, name: "团长管理" },
      // { id: 8, name: "商家发布" },
      // { id: 6, name: "帮卖物料" },
      // { id: 9, name: "门店" },
      
      formData: {
        roleId: "",
        account: "",
        jobNo: "",
        name: "",
        mobile: "",
      },

      rules: {
        roleId: [{ required: true, message: "请选择管理员权限", trigger: "change" }],
        account: [{ required: true, message: "请输入账号", trigger: "blur" }],
        jobNo: [{ required: true, message: "请输入工号", trigger: "blur" }],
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        mobile: [{ required: true, message: "请输入电话", trigger: "blur" }],
      },
    };
  },
  computed: {
    listData() {
      const start = (this.pageNum - 1) * this.pageSize;
      const end = start + this.pageSize;
      return this.allListData.slice(start, end);
    },
  },
  created() {
    this.getListData();
  },
  methods: {
    getListData() {
      this.loading = true;

      util.postData(
        API_GLYLIST,
        {},
        (res) => {
          const rawList = (res && res.data && res.data.data) || [];
          this.allListData = this.normalizeList(rawList);
          this.total = this.allListData.length;
          this.loading = false;
        },
        "application/json"
      );
    },

    normalizeList(list) {
      return (list || []).map((item) => {
        const roleId = item.roleId || item.roleid || item.role_id || "";
        return {
          id: item.id || item.adminId || item.key || "",
          jobNo: item.jobNo || item.jobno || "",
          realName: item.name || item.realName || item.realname || "",
          mobile: item.mobile || item.phone || "",
          account: item.account || item.username || "",
          roleId: roleId,
          roleName:
            item.roleName ||
            item.role ||
            item.roleDesc ||
            this.getRoleNameById(roleId) ||
            "",
        };
      });
    },

    getRoleNameById(roleId) {
      const target = this.roleOptions.find((item) => String(item.id) === String(roleId));
      return target ? target.name : "";
    },

    handleAdd() {
      this.dialog = true;
      this.resetFormData();

      this.$nextTick(() => {
        if (this.$refs.formRef) {
          this.$refs.formRef.clearValidate();
        }
      });
    },

    submitForm() {
      this.$refs.formRef.validate((valid) => {
        if (!valid) return;

        const params = new URLSearchParams();
        params.append("roleId", this.formData.roleId);
        params.append("account", this.formData.account);
        params.append("jobNo", this.formData.jobNo);
        params.append("name", this.formData.name);
        params.append("mobile", this.formData.mobile);
        console.log(this.formData)

        this.submitLoading = true;

        util.postData(API_XZGLYLB, params, (res) => {
          this.submitLoading = false;
          this.dialog = false;
          this.$message.success("添加成功");
          this.resetFormData();
          this.pageNum = 1;
          this.getListData();
        });
      });
    },

    handleDelete(row) {
      if (!row.id) {
        this.$message.warning("缺少管理员id，无法删除");
        return;
      }

      this.$confirm(
        "删除后，对应管理员账号会被删除，且不能再次登录，是否确定删除该账号？",
        "删除确认",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          this.deleteAdmin(row);
        })
        .catch(() => {});
    },

    deleteAdmin(row) {
      const params = new URLSearchParams();
      params.append("id", row.id);

      this.deleteLoading = true;

      util.postData(API_SCGLYL, params, (res) => {
        this.deleteLoading = false;
        this.$message.success("删除成功");

        if (this.listData.length === 1 && this.pageNum > 1) {
          this.pageNum -= 1;
        }

        this.getListData();
      });
    },

    handleCurrentChange(page) {
      this.pageNum = page;
    },

    resetFormData() {
      this.formData = {
        roleId: "",
        account: "",
        jobNo: "",
        name: "",
        mobile: "",
      };
    },
  },
};
</script>

<style lang="less" scoped>
.g-container-box {
  overflow: hidden;
  background: #f5f7fa;
}

.g-header-left {
  background-color: #5c6be8;
  color: #fff;
  height: 60px;
  line-height: 60px;
  text-align: center;
  font-size: 18px;
  font-weight: 600;
}

.g-menu-container {
  height: calc(100vh - 60px);
  background-color: #fff;
  border-right: 1px solid #ebeef5;
}

.g-center-container {
  overflow: auto;
  height: calc(100vh - 60px);
  background-color: #eff3f6;
  padding: 20px;
  box-sizing: border-box;
}

.admin-page-card {
  min-height: calc(100vh - 100px);
}

.page-head {
  background: #fff;
  border-radius: 10px;
  padding: 20px 24px;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
}

.page-title {
  font-size: 20px;
  line-height: 28px;
  font-weight: 600;
  color: #303133;
}

.page-desc {
  margin-top: 6px;
  font-size: 13px;
  color: #909399;
}

.add-btn {
  min-width: 110px;
  height: 38px;
  border: none;
  color: #fff;
  border-radius: 8px;
  background: linear-gradient(135deg, #f7b25b 0%, #e68b2e 100%);
  box-shadow: 0 4px 12px rgba(230, 139, 46, 0.25);
}

.add-btn:hover,
.add-btn:focus {
  color: #fff;
  opacity: 0.95;
}

.table-card {
  background: #fff;
  border-radius: 10px;
  padding: 20px 20px 10px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
}

.admin-table {
  width: 100%;
  border-radius: 6px;
  overflow: hidden;
}

.admin-table /deep/ .table-header-cell {
  background: #f7f9fc !important;
  color: #606266;
  font-weight: 600;
}

.admin-table /deep/ .el-table__row td {
  color: #606266;
}

.admin-table /deep/ .el-button--text {
  padding: 0;
}

.role-tag {
  display: inline-block;
  padding: 4px 10px;
  line-height: 1;
  border-radius: 999px;
  background: rgba(92, 107, 232, 0.08);
  color: #5c6be8;
  font-size: 12px;
}

.delete-btn {
  color: #909399;
  font-weight: 500;
}

.delete-btn:hover {
  color: #f56c6c;
}

.pagination-wrap {
  display: flex;
  justify-content: flex-end;
  padding: 20px 0 10px;
}

.admin-dialog /deep/ .el-dialog {
  border-radius: 10px;
  overflow: hidden;
}

.admin-dialog /deep/ .el-dialog__header {
  border-bottom: 1px solid #ebeef5;
  padding: 18px 20px;
}

.admin-dialog /deep/ .el-dialog__title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}

.admin-dialog /deep/ .el-dialog__body {
  padding: 24px 24px 10px;
}

.admin-form {
  padding-right: 20px;
}

.pwd-tip {
  margin: 6px 0 0 110px;
  font-size: 14px;
  color: #606266;
  line-height: 22px;
}

.pwd-tip i {
  color: #909399;
  margin-right: 6px;
}

.pwd-tip span {
  color: #303133;
  font-weight: 600;
  letter-spacing: 1px;
}

.dialog-footer {
  display: flex;
  justify-content: flex-start;
  padding-left: 110px;
}

.dialog-footer .el-button + .el-button {
  margin-left: 10px;
}

@media screen and (max-width: 1400px) {
  .admin-page-card {
    min-height: auto;
  }

  .page-head {
    padding: 16px 18px;
  }

  .table-card {
    padding: 16px 16px 8px;
  }

  .g-center-container {
    padding: 16px;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/d/index.vue